import React from 'react';
import { Section } from '@/pages/LandingComplete';
import SectionHeader from './SectionHeader';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

interface FAQContent {
  title?: string;
  titleHighlight?: string;
  items?: Array<{
    question: string;
    answer: string;
  }>;
}

export function DynamicFAQ({ content }: { content: FAQContent }) {
  const items = content.items || [];

  return (
    <Section id="faq" alternate>
      <SectionHeader
        number="06"
        title={content.title || "Häufig gestellte"}
        highlight={content.titleHighlight || "Fragen"}
      />

      <div className="max-w-4xl mx-auto">
        <Accordion type="single" collapsible className="space-y-4">
          {items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-card rounded-2xl border border-navy/10 px-6 shadow-soft hover:shadow-lift hover:border-primary/35 data-[state=open]:border-primary/45 transition-all duration-300"
            >
              <AccordionTrigger className="text-left text-lg font-bold text-navy hover:text-primary py-6 hover:no-underline">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pb-6 leading-relaxed text-base">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </Section>
  );
}
